// ** MUI Imports
import { Theme } from '@mui/material/styles';

// ** Overrides Imports
import MuiChip from './chip';
import MuiTabs from './tabs';
import MuiInput from './input';
import MuiButton from './button';
import MuiSelect from './select';
import MuiTooltip from './tooltip';
import MuiTextField from './textField';
import MuiCheckbox from './checkbox';
import MuiSkeleton from './skeleton';


const Overrides = (theme: Theme) => {
  const chip = MuiChip(theme);
  const tabs = MuiTabs(theme);
  const input = MuiInput(theme);
  const textField = MuiTextField(theme);
  const select = MuiSelect(theme);
  const button = MuiButton(theme);
  const tooltip = MuiTooltip(theme);
  const checkbox = MuiCheckbox(theme);
  const skeleton = MuiSkeleton(theme);

  return {
    ...chip,
    ...tabs,
    ...input,
    ...button,
    ...tooltip,
    ...select,
    ...textField,
    ...checkbox,
    ...skeleton,
  };
};

export default Overrides;
